export default function usePath(url) {
  if (!url) return "";

  const baseUrl = import.meta.env.VITE_API_URL || "http://localhost:8000";

  // If it's already a full URL or blob
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("blob:")) {
    // Check for double base URL: baseUrl + baseUrl
    const doubleBase = `${baseUrl}${baseUrl}`;
    if (url.startsWith(doubleBase)) {
      return url.replace(doubleBase, baseUrl);
    }
    return url;
  }

  // Prepend base URL if it doesn't have it
  const separator = url.startsWith("/") ? "" : "/";
  // If baseUrl already ends with slash, we don't need another one
  const cleanBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  return `${cleanBase}${separator}${url}`;
}
